import { createLogger } from '@/utils/logger';

(() => {
  const logger = createLogger('Polyfill');

  logger.info('Polyfill starts.');

  if (typeof Request === 'undefined') {
    logger.warn('Request is not available.');
    return;
  }

  if (!('signal' in Request.prototype)) {
    logger.info('Injecting Request.signal...');

    // Provide a mock AbortSignal so code that reads Request.signal doesn't crash in environments
    // where it's missing. This mock is inert: it never aborts and its listeners are no-ops.
    const mockAbortSignal: AbortSignal = {
      aborted: false,
      onabort: null,
      addEventListener(_type: string, _listener: any) {},
      removeEventListener(_type: string, _listener: any) {},
      dispatchEvent(_event: Event): boolean {
        return false;
      },
      // @ts-ignore - not all environments define reason/throwIfAborted on AbortSignal
      reason: undefined,
      // @ts-ignore
      throwIfAborted() {},
    } as unknown as AbortSignal;

    Object.defineProperty(Request.prototype, 'signal', {
      configurable: true,
      enumerable: false,
      get(this: any) {
        return mockAbortSignal;
      },
      // Provide a no-op setter so that accidental assignments like `req.signal = ...` do not throw
      // "attempt to assign to readonly property" in strict-mode environments (e.g., Safari).
      set(_value: any) {
        // ignore assignments; this is an inert polyfill
      },
    });
  }

  logger.info('Polyfill ends.');
})();
